module.exports = __webpack_public_path__ + "img/7.897c36c0.svg";